export default [
  // 1. 下载卫星地图
  {
    name: 'downloadMap',
    base: {
      url: '/Map/satellite/download',
      method: 'post',
      headers: {},
      data: {}
    },
    // 地图下载任务可能由后端心跳维持较长时间，前端不设置固定超时。
    config: {
      timeout: 0
    }
  },
  // 2. 查询任务状态 /satellite/download/status/{taskId}
  {
    name: 'getDownloadStatus',
    base: {
      url: '/Map/satellite/download/status/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  // 3. 下载文件 /files/{taskId}/{fileName}
  {
    name: 'downloadFile',
    base: {
      url: '/Map/files/',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  },
  // 4. 取消下载任务 /satellite/download/cancel/{taskId}
  {
    name: 'cancelDownloadFile',
    base: {
      url: '/Map/satellite/download/cancel/',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {}
  },
  // 5. 坐标转换
  {
    name: 'coordinateChange',
    base: {
      url: '/Map/coordinate/gcj02-wgs84-convert',
      method: 'post',
      headers: {},
      data: {}
    },
    config: {}
  },
  // 6. 获取瓦片服务器列表
  {
    name: 'getSatelliteTileServers',
    base: {
      url: '/Map/satellite/tile-servers',
      method: 'get',
      headers: {},
      data: {}
    },
    config: {}
  }
]
